<template>
  <v-app>
    <div class="animated fadeIn">

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <div>
         <v-row>
            <v-col>
               <ddoSelectSwitchCustomer ref="mySelect"
                  @switchCustomer="refresh_page"
               >
               </ddoSelectSwitchCustomer>
            </v-col>
         </v-row>
      </div>

      <ddoClientList ref="myResellers" :loading="loading" :level="levels[0]" 
          :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
          :customSlotNames="levels[0].customSlotNames"
          @loading="refresh_loading"
          @row="refresh_row"
          @childKey="refresh_childKey"
          @errors="refresh_errors"
          >

          <template v-slot:dialogform="{ row, level }">
            <CardUpdatableCustomerreseller ref="myCardReseller" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
               @errors="refresh_errors"
               @change_dialogValues="change_dialogValues"
            />
          </template>

          <template v-if="session_row && !session_row.cut_is_admin && !session_row.cut_is_reseller" v-slot:header="{ row, level }">
               <!-- Must return something to override default slot content -->
               <span></span>
          </template>

         <template slot="cus_active" slot-scope="props">
            <b-checkbox disabled v-model="props.row.cus_active">Actif</b-checkbox>
            <b-checkbox disabled :checked="_checked_if_notnull(props.row.cus_bm_id)">ZOHO</b-checkbox>
         </template>

        <template v-slot:superheader="{ errors }">
          <h1>{{ $t('titles.cus') }}</h1>
        </template>

      </ddoClientList>

    </div>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoSelectSwitchCustomer from '@/components/ddoSelectSwitchCustomer.vue'
import BasicList from '@/views/BasicList.vue';
import { Event } from '@/components/ddoClientList.vue';

import CardUpdatableCustomerreseller from '@/components/partials/CardUpdatableCustomerreseller.vue';
import ddoClientList from '@/components/ddoClientList.vue';
import ddoSelectPlatform from '@/components/ddoSelectPlatform.vue';
import ddoSelectService from '@/components/ddoSelectService.vue';


Vue.use(ddoClientList);

let initial_row = {}

export default {
   name: 'resellers',
   mixins: [BasicList],
   components: {
      ddoAlert,
      ddoSelectSwitchCustomer,
      CardUpdatableCustomerreseller,
      ddoClientList,
      ddoSelectPlatform,
      ddoSelectService
   },

  data: () => {
    return {
      _this: null,
      loading: false,
      session_row: null,

      cut_code_default: 'NORM',
      cut_code_fieldname: 'cut_code',

      certificates: [],

      buttonAttachPLF: true,
      selectedPLF: {},
      PLFcallbacks: {},
      PLFoptions: {
         initial: null,
         required: true,
         disabled: false,
         multiple: false,
         clearable: false,
         item_text: "plf_name",
         item_value: "plf_pk",
         item_disabled: "",
         hide_selected: true,
         label: i18n.t('texts.platform'),
      },

      buttonAttachSER: true,
      selectedSER: {},
      SERcallbacks: {},
      SERoptions: {
         initial: null,
         required: true,
         disabled: false,
         multiple: false,
         clearable: false,
         item_text: "ser_name",
         item_value: "ser_pk",
         item_disabled: "",
         hide_selected: true,
         label: i18n.t('texts.service'),
      },

      /* 
       * LEVEL 1 : all for ddoClientList : columns, options, callbacks
       */
      levels: [

      /* 
       * In 'row' object, we need to declare 'cus_name' and 'cus_code', to be reactive.
       */
      {
         api_code: 'reseller',
         api_prefix: 'cus',
         row: { cus_name: null, cus_code: null },
         session_row: {},
         level: 0,
         errors: [],
         infos: [],
         columns: [ '_actions', 'cus_active', 'cus_code', 'cus_name', '_update'],
         customSlotNames: ['cus_active'],
         searchValues: {
            cus_name: null,
            cus_active: null,
         },
         options: {
            showChildRowToggler: false,
            withChild: false,
            hiddenColumns: [],
            headings: {
               _pk: i18n.t('headers.actions'),
               _child: i18n.t('headers._details'),
               cus_active: i18n.t('texts._active'),
               cus_pk: '#',
               net_ipv4: i18n.t('headers.flags'),
               cus_code: i18n.t('headers.code'),
               cus_name: i18n.t('headers.name'),
               _update: i18n.t('headers.updated_on')
            },
            texts: {
            },
            uniqueKey: 'cus_pk',
            sortable: ['cus_code','_update'],
            filterable: false,
            sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
            columnsDropdown: false,
            columnsDisplay: {
               cus_code: 'not_mobile',
               _update: 'not_mobile',
            },
            pagination: {
               chunk: 5,
               edge: false,
               nav: 'scroll'
            },
            perPage: 100,
            perPageValues: [100,200,400],
            customFilters: [{
               name: 'search',
               callback: function (row, query) {
                  let $ret = true;
                  if ( $ret && query.cus_name!=null && query.cus_name!='' ) {
                     if ( row.cus_name && row.cus_name.indexOf(query.cus_name)<0 && row.cus_code && row.cus_code.indexOf(query.cus_name)<0 ) { $ret = false; }
                  }
                  let $ret0 = $ret;
                  if ( $ret && query.cus_active!=null && query.cus_active!='' ) {
                    if ( query.cus_active=="true" && row.cus_active==false ) { $ret = false; }
                    if ( query.cus_active=="false" && row.cus_active==true ) { $ret = false; }
                  }
                  return $ret;
               }
            }],
         },
         callbacks: {
         },
         dialogOptions: {
            codeRules : [
               (v) => !!v || i18n.t('texts._required')
            ],
            emailRules : [
               (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,24})+$/.test(v) || i18n.t('texts._email_format'),
            ],
         },
         dialogValues: {
            headers: {
               select: i18n.t('texts.cus_select_title'),
               create: i18n.t('texts.cus_create_title'),
               update: i18n.t('texts.cus_update_title'),
               delete: i18n.t('texts.cus_delete_title'),
            },
            texts: {
               create_item: i18n.t('texts.cus_create_item'),
            },
            dialogShow: false,
            form_disabled: false,
            form_close: true,
            form_create: false,
            form_update: false,
            form_delete: false,
            disable_create: true,
            disable_update: false,
            disable_delete: false,
            readonly: false,
            header_value_function: function(row) { return row['cus_code']; }
         },
      },

      ],

      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },

  created() {
    this._this = this;
    this.levels[0].callbacks.configure_form = this.configure_form;
    this.levels[0].callbacks.prepare_create = this.prepare_create_l1;
    this.levels[0].callbacks.prepare_update = this.prepare_update_l1;
    this.levels[0].callbacks.prepare_delete = this.prepare_delete_l1;
    this.levels[0].callbacks.update_row     = this.update_row_l1;    
    this.levels[0].callbacks.show_dialog    = this.show_dialog;
    this.levels[0].callbacks.refresh_errors = this.refresh_errors;
  },

   async mounted() {
      await this.refresh_session();
   },

   methods: {

      _checked_if_notnull(value) {
         console.log('_checked_if_notnull, value='+value);
         return ( value!=null ? true : false );
      },

      refresh_loading(value) {
         this.loading = value;
      },
      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },
      refresh_row(level,row) {
         this.levels[level].row = row;
      },

      async build_select_plf(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+this.levels[1].childKey+'/availableplatforms');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_plf(value,item=null) {
         if ( item!=null ) {
            this.buttonAttachPLF = false;
            this.selectedPLF = item;
         } else {
            this.selectedPLF = this.$api._get_by_pk(this.$refs.mySelectPLF.items,value);
            this.buttonAttachPLF = false;
         }
      },

      async refresh_select_plf(key=null) {
         await this.$refs.mySelectPLF.refresh_rows(key);
      },

      async build_select_ser(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+this.levels[1].childKey+'/availableservices');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_ser(value,item=null) {
         if ( item!=null ) {
            this.buttonAttachSER = false;
            this.selectedSER = item;
         } else {
            this.selectedSER = this.$api._get_by_pk(this.$refs.mySelectSER.items,value);
            this.buttonAttachSER = false;
         }
      },

      async load_for_create_by_PLF() {
         this.buttonAttachPLF = true;
         if ( this.levels[1].toggledRow ) {
            this.levels[1].customer = { cus_code: this.levels[1].toggledRow.cus_code, cus_name: this.levels[1].toggledRow.cus_name }
         }
         this.levels[1].row.cus_pk = this.levels[1].childKey;
         this.levels[1].row.xxx_maxusers = 1;
         this.levels[1].row.xxx_max_emails_per_month = null;
         this.levels[1].row.xxx_max_gigabytes_per_month = null;
         this.levels[1].row.xxx_sasl_usernames = null;
         this.levels[1].row.array_usernames = []; // required
         this.levels[1].row = { ...this.levels[1].row, ...this.selectedPLF }
         await this.$refs.myCustomerPlatforms.load_for_create();
         this.buttonAttachPLF = false;
      },

      async load_for_create_by_SER() {
         this.buttonAttachSER = true;
         if ( this.levels[1].toggledRow ) {
            this.levels[1].customer = { cus_code: this.levels[1].toggledRow.cus_code, cus_name: this.levels[1].toggledRow.cus_name }
         }
         this.levels[1].row.cus_pk = this.levels[1].childKey;
         this.levels[1].row.xxx_maxusers = 0;
         this.levels[1].row.xxx_max_emails_per_month = null;
         this.levels[1].row.xxx_max_gigabytes_per_month = null;
         this.levels[1].row.xxx_sasl_usernames = null;
         this.levels[1].row.array_usernames = []; // required
         this.levels[1].row = { ...this.levels[1].row, ...this.selectedSER }
         await this.$refs.myCustomerPlatforms.load_for_create();
         this.buttonAttachSER = false;
      },

      splitString(items) {
         // steps is a comma-separated string. We need to transform it in an array
         if ( typeof items == "string" ) {
            return items.split(',');
         } else {
            return [];
         }
      },

      async prepare_update_l1(parentKey,_pk,row,origin) {
         this.levels[0].errors = [];
         this.levels[0].infos = [];
         this.levels[0].row.cus_code = row.cus_code;
         this.$refs.myCardCustomerreseller.CUToptions.selected = row.cut_pk;
         this.$refs.myCardCustomerreseller.CTCoptions_general.selected = row.ctc_pk_general;
         this.$refs.myCardCustomerreseller.CTCoptions_invoicing.selected = row.ctc_pk_invoicing;
         this.$refs.myCardCustomerreseller.CTCoptions_shipping.selected = row.ctc_pk_shipping;
         this.$refs.myCardCustomerreseller.CTCoptions_general.triggers_refresh = true;
         this.$refs.myCardCustomerreseller.CTCoptions_invoicing.triggers_refresh = true;
         this.$refs.myCardCustomerreseller.CTCoptions_shipping.triggers_refresh = true;
         if ( row.cut_is_customer==true && row.cus_bm_id==null ) {
            var infos = { err_type: 'warning', err_value_text: this.$i18n.t('texts.cus_bm_id_warning') };
            this.levels[0].infos = [infos];
         }
      },

      async update_row_l1(router,api_code,_pk,row) {
         var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,row,'update_essentials');
         //console.log('update_row_l1, api_respinse='+JSON.stringify(api_response))
         return { errorinfos, api_response }
      },

      async refresh_session() {
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         //console.log('refresh_session, session='+JSON.stringify(api_response.row))
         if ( api_response.error==0 && api_response.row ) {
            this.session_row = api_response.row;
            this.levels[0].session_row = api_response.row;
         }
      },

      recompute_values() {
         if ( this.session_row!=null ) {
            var readonly = this.session_row.cut_is_customer;
            this.levels[0].dialogValues.readonly = readonly;
         }
      },

      async refresh_page(session_row) {
         this.session_row = session_row;
         this.levels[0].session_row = session_row;
         await this.$refs.myResellers.refresh_rows();
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         console.log('show_dialog, level='+level+', row='+JSON.stringify(this.levels[level].row));
         if ( level==1 ) {
            _dV.dialogShow = { smtppro: false, smspro: false, exchange: false, ldap: false, bareos: false };
         } else {
            _dV.dialogShow = show;
         }
         this.levels[level].dialogValues = _dV;
      },

      hide_dialog(level) {
         this.show_dialog(level,false);
      },

      check_skip_confirm(method,row) {
         var check = false;
         switch (method) {
            case 'create':
            case 'update':
               check = (row.xxx_changes_sasl_usernames==null);
               break;
            case 'delete':
               row.xxx_changes_sasl_usernames = [];
               if ( row.xxx_sasl_usernames!=null ) {
                  var list = row.xxx_sasl_usernames.split(',');
                  var deletelist = [];
                  for ( var i=0; i<list.length;i++ ) {
                     deletelist.push( {username: list[i]} );
                  }
                  row.xxx_changes_sasl_usernames = { delete: deletelist }
               }
               break;
         }
         return check;
      },

      change_dialogValues(level,property,value) {
         console.log('change_dialogValues, level='+level+', property='+property+', value='+value)
         this.levels[level].dialogValues[property] = value;
      },

   }
}
</script>